import type { IconSvgObject } from './types';

const MouseRightClick04Icon: IconSvgObject = [
  ["path", { d: "M10.5 6V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 6H10C9.44772 6 9 6.44772 9 7V9C9 9.55228 9.44772 10 10 10H11C11.5523 10 12 9.55228 12 9V7C12 6.44772 11.5523 6 11 6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 2C20.0547 3.13158 20.7646 4.50113 21 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10.5 22C16.5 22 18 17.49 18 12C18 6.50998 16.5 2 10.5 2C4.49993 2 3 6.50996 3 12C3 17.49 4.49993 22 10.5 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MouseRightClick04Icon;
